export class CoCobranzadetallePk {
    unidadreplicacion: string;
    cobranzanumero: number;
    linea: number;
}
export class CoCobranzadetalle {
    pk: CoCobranzadetallePk;
    constructor() {
        this.pk = new CoCobranzadetallePk();
    }

    tipopago: string;
    monedapago: string;
    banco: string;
    tarjetacreditocodigo: string;
    documentoreferencia: string;
    cuentabancariapropia: string;
    arqueodocumentoreferencia: string;
    recibonumero: string;
    retencioncertificado: string;
    estado: string;
    ultimousuario: string;
    descuentoestado: string;
    descuentovoucheranulacion: string;

    montolocal: number;
    montodolares: number;
    tipocambiopago: number;
    arqueonumero: number;
    retencionmontoimponible: number;
    retencionporcentaje: number;
    indicadorarchivamiento: number;

    retencionfecha: Date;
    ultimafechamodif: Date;

    utilizarBancoFlag: string;
    utilizarDocumentoFlag: string;
    utilizarTarjetaCreditoFlag: string;
    conciliableflag: string;
    retencionFlag: string;
    cuentabancaria: string;
    
}